export const EDIT_REQUEST = 'EDIT_REQUEST';
export const EDIT_FAILURE = 'EDIT_FAILURE';
export const EDIT_SUCCESS = 'EDIT_SUCCESS';
export const CLEAR_STORE = 'CLEAR_STORE';